import { render, staticRenderFns } from "./gathering-submitted.vue?vue&type=template&id=751cc1ea&"
import script from "./gathering-submitted.vue?vue&type=script&lang=js&"
export * from "./gathering-submitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports